import React,{Component} from 'react'
import axios from '../../http-config'
import { connect } from 'react-redux';
import * as actionsCreators from  '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import {Doughnut,Line} from 'react-chartjs-2';
import BasicTable from './Table'
import BasicTableArea from './tableArea'
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';

class Chart extends Component{


  state = {
    filter : {
      'interval':'',
    },
    data:[],
    id:'',
    isDisabled:false,
    interval:'Current Day'
  }
  componentDidMount=()=>{
      let payload = {
        token: this.props.token,
        filter: JSON.stringify([this.state.filter]),
        interval:this.state.interval

    }
       this.props.onFetchDashboardData(payload)
    }

  render(){
    let dashboard_data =!!this.props.data.dashboard_data&& this.props.data.dashboard_data
    let colors = []
    let values = []
    let pie_chart_labels = []
    let line_chart_labels = []
    let line_chart_data   = []
    let rows = []
    let TableDataBody = []
    let columnsDataHeaders = []
    if(dashboard_data){
    dashboard_data[0].property_type.forEach(function(property_type) {
       colors.push(property_type.Color)
       values.push(property_type.Count)
       pie_chart_labels.push(property_type.Name)

    });
    dashboard_data[0].date_wise_loads.forEach(function(date_wise_load) {
      line_chart_labels.push(date_wise_load.DateTime)
      line_chart_data.push(date_wise_load.Count)
    });
    rows = dashboard_data[0].tf_data.body
    TableDataBody = dashboard_data[0].table_data.body
    columnsDataHeaders= dashboard_data[0].table_data.headers
    }
    
    //const final=[]
    //const color=['#8dd3c7','#ffffb3','#bebada','#fb8072','#80b1d3','#fdb462','#b3de69','#fccde5','#d9d9d9']
    //const  data=[300, 50, 100,76,65,143,98,67,86]
    const color  = colors
    const data   = values
    const labels = pie_chart_labels
    // const results =[...this.props.propertyTypes]
    //     for (const result of results){
    //       for(const item in result){
    //       final.push(result[item])
    //       }
    //     }

    let minTick         = Math.min(...line_chart_data) - (Math.max(...line_chart_data)*0.1) < 0 ? 0 : Math.round(Math.min(...line_chart_data) - (Math.max(...line_chart_data)*0.1))
    let maxTick         = Math.ceil(Math.max(...line_chart_data) + (Math.max(...line_chart_data)*0.1))
    const tickDifference  = Math.ceil(maxTick/10)
    maxTick = Math.max(...line_chart_data) + tickDifference
    minTick = Math.min(...line_chart_data) - tickDifference < 0 ? 0 : Math.round(Math.min(...line_chart_data) - tickDifference)


    const maindata = {
      labels:labels,
      datasets: [{
          data:data,
          backgroundColor:color,
      }],
      options:{
      legend:{
        position:"right",
        align:"middle"
      }
      }
    };

    var lineChartOptions = {
      showScale: true,
      //pointDot: true,
      //showLines: false,
      title: {
        display: true,
        text: 'Day Wise Loads'
    },
      legend: {
        display: true,
        labels: {
          boxWidth: 50,
          fontSize: 12,
          fontColor: 'rgb(115 115 115)',
          padding: 5,
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            //beginAtZero:true,
            autoSkip: true,
            min: minTick,
            maxTicksLimit: tickDifference,
            max: maxTick
          },
          scaleLabel: {
            boxWidth: 50,
            fontSize: 12,
            fontColor: '#3DAB35',
            padding: 10,
            display: true,
            labelString: 'No of Loads',
            fontStyle: "bold",
          }
        }],
        xAxes: [{
          scaleLabel: {
            boxWidth: 50,
            fontSize: 12,
            fontColor: '#3DAB35',
            padding: 10,
            display: true,
            labelString: 'Days',
            fontStyle: "bold",

          }
        }]
      }

    }

    const lineData =  {
      labels: line_chart_labels,
      datasets: [
        {
          color:"#3DAB35",
          label:"Collected Loads",
          fill: false,
          lineTension: 0.1,
          borderColor:  "#3DAB35",
          pointRadius: 5,
          pointBorderColor: "#3DAB35",
          pointBackgroundColor: "#3DAB35",
          data: line_chart_data,
        }  
      ]
    };

    return(
    <Grid>
      <Grid container spacing={3} direction="row"> 
        <Grid item xs={6}>
          <Paper height={500}><hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr><Line data={lineData} options = {lineChartOptions} width={800} height={300} align="left"/></Paper>  
          <br/>
          <br/>
          <Paper height={500}><hr style={{border: "1px solid #3DAB35", marginLeft:"5%",width:"30px"}}></hr><Doughnut data={maindata}  
            options={{
              legend:{
                display:true,
                position:'right',
                labels: {
                  boxWidth: 50,
                  fontSize: 10,
                  fontColor: 'rgb(115 115 115)',
                  padding: 4,
                }
              },
              title: {
                display: true,
                text: 'Property Type Wise Loads'
            },
            layout: {
              padding: {
                left: 10,
                right: 10,
                top: 10,
                bottom: 10,
              }
            }
            }} 
            width={800} height={300} /></Paper> 
        </Grid>
        <Grid item xs={6}>
        <Paper><hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr><BasicTable rows={rows} TableDataBody={TableDataBody} columnsDataHeaders={columnsDataHeaders} height="1500px"/></Paper> 
          <br/>
          <br/> 
          <Paper><hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr><BasicTableArea rows={rows} TableDataBody={TableDataBody} columnsDataHeaders={columnsDataHeaders} height="1500px"/></Paper>
        </Grid>
      </Grid>
    </Grid>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.dashboard.dashboard,
    loading: state.loads.loading,
    token: state.auth.token

  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchDashboardData: (payload) => dispatch(actionsCreators.fetchDashboard(payload))
  }
}

export default  connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Chart, axios));
